<template>
  <div class="box">
    <div v-if="loadingStatus || loadingTicket" class="loading-indicator">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <h3 class="stitle1 mb30">{{ showReserveBtn ? productItem.mrktnPdNm : '예약옵션' }}</h3>
    <accordion always-open ref="accordion" class="ticket-accordion">
      <accordion-item default-open>
        <template slot="accordion-trigger">
          <dl class="buy_date">
            <dt class="stitle2">체험일자</dt>
            <dd>{{ date }}</dd>
          </dl>
        </template>
        <template slot="accordion-content">
          <div class="content-block">
            <v-date-picker
              class="ticket-calendar"
              ref="calendar"
              is-expanded
              is-required
              :min-date="productItem.rvpossStartDt"
              :max-date="productItem.rvpossEndDt"
              :disabled-dates="allDisabledDates"
              :model-config="modelConfig"
              :attributes="holidays"
              @update:from-page="onChangeCalPage"
              v-model="date"
            >
              <template v-slot:header-title="slotProps">{{ `${slotProps.year}년 ${slotProps.monthLabel}` }}</template>
            </v-date-picker>
          </div>
        </template>
      </accordion-item>
      <accordion-item :disabled="scheSeqNoDisabled" ref="scheRef">
        <template slot="accordion-trigger">
          <dl class="buy_date">
            <dt class="stitle2">{{ this.productItem.productOption === 'Y' ? '프로그램' : '체험시간' }}</dt>
            <dd>{{ viewScheSeqNo }}</dd>
          </dl>
        </template>
        <template slot="accordion-content">
          <div class="content-block">
            <ol class="sel_time ckbox_wrap" v-if="schedule && schedule.length > 0">
              <li class="checkbox" v-for="tt in schedule" :key="tt.mrktnScheSeqNo">
                <input type="radio" :id="tt.mrktnScheSeqNo" :value="tt.mrktnScheSeqNo" v-model="mrktnScheSeqNo" />
                <label :for="tt.mrktnScheSeqNo">
                  <span>{{ tt.mrktnScheSeqNm }}({{ tt.tm }})</span>
                  <strong>잔여: {{ tt.rvResiduePcnt }}</strong>
                </label>
              </li>
            </ol>
            <div v-else>선택 가능한 회차가 없습니다.</div>
          </div>
        </template>
      </accordion-item>
      <accordion-item v-if="productPriceListNotHide && productPriceListNotHide.length > 0" ref="pcntRef">
        <template slot="accordion-trigger">
          <dl class="buy_date">
            <dt class="stitle2">{{ pcntListNm }}</dt>
            <dd>총 {{ totalPcnt }}명</dd>
          </dl>
        </template>
        <template slot="accordion-content">
          <div class="content-block">
            <ul class="pers_list">
              <li v-for="(pl, i) in productPriceListNotHide" :key="i">
                <span>{{ pl.reciDivNm }}</span>
                <i>{{ pl.formatedPrice }}</i>
                <count-button
                  title="인원"
                  :value="pl.pcnt"
                  :max="maxPcnt"
                  :onChange="onPcntChange"
                  :target="pl"
                  :disabled="pl.disabled"
                  :valid="getValidFn(pl)"
                />
              </li>
            </ul>
          </div>
        </template>
      </accordion-item>
      <!-- <accordion-item
        v-if="productItem.mrktnPdYn !== 'Y'"
        v-for="(pdExph, i) in productExphList"
        :key="'pdExph_' + i + '_' + pdExph.scheSeqNo"
        :default-open="pdExph.defaultOpen"
      > -->
      <accordion-item
        v-if="productItem.mrktnPdYn !== 'Y'"
        v-for="(pdExph, i) in productExphList"
        :key="'pdExph_' + i + '_' + pdExph.scheSeqNo"
        :default-open="mrktnScheSeqNo > 0"
        :disabled="scheSeqNoDisabled"
        ref="exphRef"
      >
        <template slot="accordion-trigger">
          <dl class="buy_date">
            <dt class="stitle2">{{ pdExph.exphListNm }}</dt>
            <dd>{{ pdExph.exphTotPcnt }} 명</dd>
          </dl>
        </template>
        <template slot="accordion-content">
          <div class="sub-content">
            <product-exp-table :totPcnt="pdExph.exphTotPcnt" :maxTotPcnt="pdExph.maxTotPcnt" :roadList="pdExph.roadList" :onChange="onRoadPcntChange(pdExph)" />
          </div>
        </template>
      </accordion-item>
      <div v-if="showMrktExph">
        <accordion ref="pcntAcco" class="ticket-accordion">
          <accordion-item v-for="(mp, i) in mrktExphPcntList" :key="mp.uniqueId" default-open :disabled="scheSeqNoDisabled">
            <template slot="accordion-trigger">
              <dl class="buy_date">
                <dt class="stitle2">{{ mp.incluNm || '체험자 ' + (i + 1) }} 체험실 선택</dt>
                <dd></dd>
              </dl>
            </template>
            <template slot="accordion-content">
              <div class="content-block">
                <accordion ref="exphAcco" class="ticket-accordion">
                  <accordion-item v-for="(pdExph, j) in productExphList" :key="'pdExph_' + j + '_' + pdExph.scheSeqNo">
                    <template slot="accordion-trigger">
                      <dl class="buy_date">
                        <dt>{{ pdExph.exphListNm }}</dt>
                        <dd>{{ mp.expProduct[j].exhpNm }}</dd>
                      </dl>
                    </template>
                    <template slot="accordion-content">
                      <div class="sub-content">
                        <product-exp-table
                          :radio="true"
                          :name="pdExph.pdDiv + '_' + j + '_' + pdExph.scheSeqNo"
                          :checked="mp.expProduct[j].exhpHzCd"
                          :totPcnt="pdExph.exphTotPcnt"
                          :maxTotPcnt="pdExph.maxTotPcnt"
                          :roadList="pdExph.roadList"
                          :onChange="onMrktnRoadPcntChange(mp.expProduct[j], pdExph)"
                        />
                      </div>
                    </template>
                  </accordion-item>
                </accordion>
              </div>
            </template>
          </accordion-item>
        </accordion>
      </div>
    </accordion>
    <div class="totalBox">
      <span class="tt_text">총 금액</span>
      <span class="tt_num">
        <coupon-popup v-if="productItem.mrktnPdYn === 'N'" v-model="ticket.couponsaleSeq" :booking="reserveInfo">
          <a class="cuppon">쿠폰</a>
        </coupon-popup>
        <span v-if="originPrice !== saleAmt" class="org-price">{{ originPrice.toLocaleString() }}</span>
        <strong class="ttPrice" :class="{ 'price-loading': loadingPrice }">{{ formatedTotal }}</strong>
      </span>
    </div>
    <!-- 예약대기 오픈시 제외 -->
    <div v-if="false && currentRouteType === 'grp' && outOfStock" class="block">
      <reserve-wait-popup />
    </div>
    <template v-else-if="$route.query.t !== 'preview'">
      <div v-if="showReserveBtn">
        <!-- 개인과 온잡, 온잡은 단체 예약도 확약서로 받지 않는다.-->
        <div v-if="currentRouteType === 'ind'" class="btn_wrap mt30">
          <a class="btn_bg line wdhalf" v-if="productItem.mrktnPdYn !== 'Y'" @click="onAddCartClick">체험바구니 담기</a>
          <a class="btn_bg color wdful" :class="{ wdhalf: productItem.mrktnPdYn !== 'Y' }" @click="onPaymentClick">결제하기</a>
        </div>
        <template v-else>
          <template v-if="d">
            <!-- 초청행사 URL 접근시 -->
            <div class="btn_wrap mt30">
              <a class="btn_bg line wdhalf" v-if="productItem.mrktnPdYn !== 'Y'" @click="onJustAddCartClick">체험바구니 담기</a>
              <a class="btn_bg line wdhalf" v-if="productItem.mrktnPdYn !== 'Y'" @click="onGoCartClick">체험바구니로</a>
            </div>
            <div class="btn_wrap mt10">
              <a class="btn_bg color wdful" @click="onPledgeCmplClick">바로 예약하기</a>
            </div>
          </template>
          <template v-else>
            <!-- notPledegeOnly => 평일단체예약제 확약서 예약만 가능 -->
            <template v-if="notPledegeOnly()">
              <div class="btn_wrap mt30">
                <a class="btn_bg line wdful" v-if="productItem.mrktnPdYn !== 'Y'" @click="onAddCartClick">체험바구니 담기</a>
              </div>
              <div class="btn_wrap mt10">
                <a class="btn_bg line wdhalf" @click="onPledgeClick">확약서 예약하기</a>
                <a class="btn_bg color wdhalf" @click="onPaymentClick">결제하기</a>
              </div>
            </template>
            <template v-else>
              <div class="btn_wrap mt30">
                <a class="btn_bg line wdful" @click="onPledgeClick">확약서 예약하기</a>
              </div>
            </template>
            <div class="mt50">
              <strong>확약서</strong>
              <br />
              기관 특성상 선결제가 어려운 경우 체험당일 현장결제를 약속하는 문서로 15명 이상의 단체고객에 한하여 진행할 수 있습니다.
              <br />
              ※ 선결제가 가능한 단체는 선결제를 권장합니다.
              <br />
              ※ 확약서 승인은 체험일 15일 전 가능하며 승인 후 청소년체험관, 숙련기술체험관 체험실 예약이 가능합니다.
              <template v-if="notPledegeOnly()">
                <br />
                <br />
                <strong>결제하기</strong>
                <br />
                청소년체험관, 숙련기술체험관을 예약하시는 고객께서는 결제 후 바로 체험실 예약이 가능합니다.
              </template>
            </div>
          </template>
        </template>
      </div>
      <div v-else class="block">
        <div class="btn_wrap mt30"><a class="btn_bg color wdful" @click="onBookingClick">예약하기</a></div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { orderValid, orderPledge } from '@/utils/reserve';
import moment from 'moment';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import Accordion from '@/components/common/Accordion.vue';
import AccordionItem from '@/components/common/AccordionItem.vue';
import CountButton from '@/components/common/CountButton.vue';
import ProductExpTable from '@/components/product/detail/ProductExpTable.vue';
import ReserveWaitPopup from '@/components/popup/ReserveWaitPopup.vue';
import CouponPopup from '@/components/popup/CouponPopup';
import { VueLoading } from 'vue-loading-template';
import 'vue-date-pick/dist/vueDatePick.css';

export default {
  name: 'ProductTicket',
  components: { vDatePicker: DatePicker, Accordion, AccordionItem, ProductExpTable, CountButton, ReserveWaitPopup, CouponPopup, VueLoading },
  props: {},
  data() {
    return {
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      showReserveBtn: this.$route.name === 'pcntInfo' || this.$route.name === 'groupInfo',
      priceLoadingSize: { width: '30px', height: '30px' },
      checkExperPcnt: () => {},
    };
  },
  computed: {
    ...mapState('reserve', [
      'loadingStatus',
      'loadingTicket',
      'loadingPrice',
      'productItem',
      'ticket',
      'calendar',
      'schedule',
      'exceDtList',
      'pcntListNm',
      'productPriceList',
      'productExphList',
      'experPcntList',
      'leaderPcntList',
      'orgInfo',
      'childAgeAgree',
      'privateAgree',
      'mktAgree',
    ]),
    ...mapGetters('reserve', ['originPrice', 'saleAmt', 'reserveInfo', 'experPcnt', 'isYouthOrSkill', 'chkChildAge', 'chkYouthAge', 'chkSkillAge']),
    ...mapState({ isLoggedIn: (state) => state.ui.isLoggedIn }),
    disabledWeekdays() {
      //pdInclDays: 일요일:0, 토요일:6,
      //컴포넌트: 일요일:1, 토요일:7
      const availableWeekdays = this.productItem.pdInclDays?.split(',').map((e) => parseInt(e) + 1);
      const disabledWeekdays = [];
      if (!availableWeekdays) return [];

      for (let i = 1; i < 8; i++) {
        if (!availableWeekdays.includes(i)) {
          disabledWeekdays.push(i);
        }
      }
      return disabledWeekdays;
    },
    exceDates() {
      return this.exceDtList.map((e) => ({ pdExceDt: moment(e.pdExceDt, 'YYYYMMDD').toDate(), pdExceDiv: e.pdExceDiv }));
    },
    disabledDates() {
      const calDates = this.calendar?.filter((e) => e.holidayType === 2).map((e) => moment(e.dt, 'YYYY-MM-DD').toDate()) || []; // 휴관일
      const disable = this.exceDates.filter((e) => e.pdExceDiv === '0').map((e) => e.pdExceDt); // 예외 운영일
      //const enable = this.exceDates.filter((e) => e.pdExceDiv === '1').map((e) => e.pdExceDt.getTime()); // 추가 운영일 개선(23.07.26.)
      //const filtered = calDates.filter((e) => !enable.includes(e.getTime())); // 추가 운영일 개선(23.07.26.)

      const enableDates = this.exceDates.filter((e) => e.pdExceDiv === '1').map((e) => moment(e.pdExceDt, 'YYYY-MM-DD').toDate()); // 추가 운영일
      const disabledDates = []; // 비활성 날짜 변수
      const today = new Date();

      // 비활성 날짜 생성 - 추가 운영일 기능 + 비활성 weekdays 통합
      this.calendar?.forEach((obj) => {
        const date = moment(obj.dt, 'YYYY-MM-DD').toDate();
        const date1 = moment(obj.dt, 'YYYY-MM-DD').toDate();
        //date.setHours(14,20,0,0);
        //달력 막히는 시간설정.
        date1.setHours(14, 0, 0, 0);
        const day = date.getDay() + 1; // 일요일:0, 토요일:6 -> 일요일:1, 토요일:7
        const calDateChk = calDates.some((cd) => cd.toISOString() == date.toISOString()); // 휴관일 확인
        const enableChk = enableDates.some((ed) => ed.toISOString() == date.toISOString()); // 추가 운영일 확인

        // 휴관일 이거나 비활성화 요일 확인
        if (this.disabledWeekdays.includes(day) || calDateChk) {
          // 추가운영일 확인
          if (!enableChk) {
            disabledDates.push(date);
          }
        }
        /*else if (this.productItem.pdDiv ==='09') {
          if (date1 <= today) {
          // 오늘 포함 이전 날짜 제외
            console.log("제외:"+date);
            disabledDates.push(date);
        }
        } */
        // 미래직업관 한번 더! 1+1만 적용
        else if (this.productItem.mrktnPdNo === '100513') {
          if (date <= today) {
            disabledDates.push(date);
          }
        }
        //어체만 적용
        else if (this.productItem.pdDiv === '01') {
          if (date1 <= today) {
            // 오늘 포함 이전 날짜 제외
            disabledDates.push(date);
          }
        } else if (date <= today) {
          // 오늘 포함 이전 날짜 제외
          disabledDates.push(date);
        }
        // 청소년체험관 마케팅상품 당일 예약 제외
        if (this.productItem.pdDiv === '02' && date <= today) {
          disabledDates.push(date);
        }
      });
      //return [...disable, ...filtered]; // 추가 운영일 개선(23.07.26.)
      return [...disable, ...disabledDates];
    },
    allDisabledDates() {
      const allDisabledDates = [...this.disabledDates];
      //allDisabledDates.push({ weekdays: this.disabledWeekdays }); // 추가 운영일 개선(23.07.26.)
      return allDisabledDates;
    },
    holidays() {
      return [
        {
          key: 'holidays',
          highlight: {
            contentClass: 'holidays',
            //contentStyle: { color: '#e12f36' },
          },
          dates: this.calendar?.filter((e) => e.holidayType > 0).map((e) => moment(e.dt, 'YYYY-MM-DD').toDate()),
        },
        // {
        //   key: 'weekend',
        //   highlight: {
        //     contentStyle: { color: '#f6aaad', pointerEvents: 'none' },
        //   },
        //   dates: this.calendar?.filter((e) => e.holidayType === 2).map((e) => moment(e.dt, 'YYYY-MM-DD').toDate()),
        // },
      ];
    },
    date: {
      get() {
        return this.$store.state.reserve.ticket.date;
      },
      set(value) {
        this.changeTicketInfo({ date: value });

        //const today = new Date().toLocaleDateString('en-CA');
        //if(value === today){
        //alert("당일 예약입니다.");
        //}
        if (value === '2026-01-21' && this.productItem.pdDiv === '02') {
          alert(': 1월 21일 (수) <로봇공학연구소> 3~4부는 당일 타 체험관 행사로 인해 휴머노이드로봇으로만 체험 진행될 예정입니다(사족보행로봇 X)');
        }
      },
    },
    mrktnScheSeqNo: {
      get() {
        return this.$store.state.reserve.ticket.mrktnScheSeqNo;
      },
      set(value) {
        this.changeScheSeqNo(value);
      },
    },
    selectedSche() {
      return this.schedule.find((e) => e.mrktnScheSeqNo === this.ticket.mrktnScheSeqNo);
    },
    maxPcnt() {
      if (this.groupPersDiv === '01') {
        return Math.max(15, this.selectedSche?.rvResiduePcnt);
      } else {
        return this.selectedSche?.rvResiduePcnt || 0;
      }
    },
    viewScheSeqNo() {
      if (!this.date) {
        return '날짜를 선택해 주세요';
      } else {
        const selected = this.schedule.find((e) => e.mrktnScheSeqNo === this.mrktnScheSeqNo);
        if (selected) {
          this.changeTicketInfo({ scheTime: selected.tm });
          return selected.mrktnScheSeqNm + '(' + selected.tm + ')';
        } else {
          this.changeTicketInfo({ scheTime: '' });
          return '시간을 선택해 주세요';
        }
      }
    },
    leaderPcnt: {
      get() {
        return this.$store.state.reserve.ticket.leaderPcnt;
      },
    },
    totalPcnt() {
      return this.experPcnt + this.leaderPcnt;
    },
    formatedTotal() {
      if (!this.date) {
        return '날짜 선택';
      } else if (this.experPcnt + this.leaderPcnt > 0) {
        return this._wonFormat(this.saleAmt, '무료');
      } else {
        return '인원 선택';
      }
    },
    outOfStock() {
      if (this.selectedSche) {
        return this.selectedSche.rvResiduePcnt - this.experPcnt >= 0 ? false : true;
      } else {
        return false;
      }
    },
    showMrktExph() {
      return this.productItem.mrktnPdYn === 'Y' && this.experPcntList.some((e) => e.showExph);
    },
    mrktExphPcntList() {
      return this.productItem.mrktnPdYn === 'Y' ? this.experPcntList.filter((e) => e.showExph) : [];
    },
    scheSeqNoDisabled() {
      return !this.date;
    },
    productPriceListNotHide() {
      return this.productPriceList.filter((e) => e.hide !== true);
    },
    /* 시작, 종료일 */
    d() {
      return this.$route.query.d || '';
    },
  },
  watch: {
    $route(to, from) {
      this.showReserveBtn = to.name === 'pcntInfo' || to.name === 'groupInfo';
      if (to?.name?.endsWith('product detail desc')) {
        const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (w <= 540) {
          this.$refs.accordion.allOpen();
        }
      }
    },
    date(to, from) {
      if (to?.substr(0, 7) !== from?.substr(0, 7)) {
        this.$refs.calendar.move(to);
      }
      if (to) {
        this.$refs.scheRef.forceOpen();
      }
    },
    mrktnScheSeqNo(to) {
      if (to) {
        if (this.$refs.pcntRef) {
          this.$refs.pcntRef.forceOpen();
        }
        if (this.$refs.exphRef && this.$refs.exphRef.length > 0) {
          this.$refs.exphRef.forEach((e) => e.forceOpen());
        }
      }
    },
    productItem(to) {
      if (!this.date) {
        if (to.rvpossStartDt) {
          this.$refs.calendar.move(to.rvpossStartDt);
        } else {
          this.$refs.calendar.move(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate());
        }
      }
    },
    experPcnt: function (to) {
      this.checkExperPcnt(to);
    },
    ticket: {
      deep: true,
      handler: function (to, from) {
        this.calcPrice(this.groupPersDiv);
      },
    },
  },
  methods: {
    ...mapActions(['editReserveInfo', 'changeCustomerCount', 'addCartItem', 'updateBookingList']),
    ...mapActions('reserve', [
      'getCalendar',
      'changeTicketInfo',
      'changeScheSeqNo',
      'changeTicketPcnt',
      'calcPrice',
      'changeMrktnRoadPcnt',
      'clearPcnt',
      'getProductSchedule',
    ]),
    onChangeCalPage(page) {
      this.getCalendar(moment(new Date(page.year, page.month - 1, 1)).format('YYYY-MM-DD'));
    },
    onSelectTime(time) {
      this.editReserveInfo({ time });
    },
    onPcntChange(value, target) {
      this.changeTicketPcnt({ pgDiv: this.pgDiv, target, value });
      this.calcPrice(this.groupPersDiv);
    },
    onRoadPcntChange(productExph) {
      return (value, target) => {
        this.$store.commit('reserve/UPDATE_ROAD_PCNT', { productExph, target, value });
        this.calcPrice(this.groupPersDiv);
      };
    },
    onMrktnRoadPcntChange(target, productExph) {
      return (value) => {
        this.changeMrktnRoadPcnt({ productExph, target, value });
      };
    },
    cancelCoupon() {
      this.changeTicketInfo({ couponsaleSeq: 0 });
    },
    pcntVaild() {
      //개인
      if (this.pgDiv === 'P') {
        return function (value) {
          let rtn = false;
          if (value >= 15) {
            rtn = true;
            customConfirm('개인예약은 14인 이하만 예약 가능합니다.\n단체예약으로 진행하시겠습니까?', (confirm) => {
              if (confirm) {
                location.href = location.pathname.replace('/ind/', '/grp/');
                // this.$router.push({
                //   path: this.$router.currentRoute.path.replace('/ind/', '/grp/'),
                // });
              }
            });
          }
          return rtn;
        };
        //단체
      } else {
        return function (value) {
          let rtn = false;
          if (value < 15) {
            alert('단체예약은 15인 이상 가능합니다.\n체험인원을 확인해주세요.\n(14인 이하는 개인예약으로 진행해주세요.)');
            rtn = true;
          }
          return rtn;
        };
      }
    },
    getValidFn(info) {
      //체험자
      if (info.reciDivCd === '20') {
        return this.pcntVaild();
        //보호자
      } else if (info.reciDivCd === '10') {
        return () => false;
      }
    },
    onBookingClick: function () {
      if (this.isLoggedIn) {
        if (!this.date) {
          alert('날짜를 선택해 주세요.');
          return false;
        }
        if (this.experPcnt === 0) {
          alert('체험자를 선택해 주세요.');
          return false;
        }
        if (this.outOfStock) {
          alert('예약 가능한 인원을 초과하였습니다.');
          return false;
        }
      }

      this.$router
        .push({
          path: this.$router.currentRoute.path + '/reserve' + (this.d ? `?d=${this.d}` : ''),
        })
        .then((e) => {
          const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          if (w <= 540) {
            this.$refs.accordion.allClose();
          }
        });
    },
    async onAddCartClick() {
      if (await this.reserveValid()) {
        const item = { ...this.reserveInfo, groupPersDiv: this.groupPersDiv };
        const result = await this.addCartItem({ cartItem: item, replace: false });
        this.cancelCoupon();
        if (result) {
          customConfirm('상품이 체험바구니에 추가되었습니다. 체험바구니로 이동하시겠습니까?', (confirm) => {
            if (confirm) {
              this.$router.push('/' + this.currentRouteType + '/cart');
            } else {
              //개인 && 마케팅 아니고 && 체험실 기반
              if (this.groupPersDiv === '02' && this.productItem.mrktnPdYn !== 'Y' && this.productItem.capaPcntType === '01') {
                this.clearPcnt();
                this.getProductSchedule({ id: this.reserveInfo.mrktnPdNo, pgDiv: this.pgDiv, dt: this.date, seq: this.mrktnScheSeqNo, allNew: true });
                this.$router.go(-1);
              }
            }
          });
        }
      }
    },
    async onPaymentClick() {
      if (await this.reserveValid()) {
        const item = { ...this.reserveInfo, groupPersDiv: this.groupPersDiv };
        this.updateBookingList({ bookingList: [item], mode: 'normal' });
        this.$router.push('/' + this.currentRouteType + '/payment');
      }
    },
    async onPledgeClick() {
      if (await this.reserveValid()) {
        this.updateBookingList({ bookingList: [{ ...this.reserveInfo, groupPersDiv: this.groupPersDiv }], mode: 'pledge' });
        // 가예약 검증
        if (!(await orderPledge([{ ...this.reserveInfo }]))) return false;
        this.$router.push('/' + this.currentRouteType + '/payment');
      }
    },
    async reserveValid() {
      if (this.reserveInfo.mrktnPdNo === 100035 && !this.mktAgree) {
        alert('150분 할인권, 이용 시 필수 조건을 확인해 주세요.');
        return false;
      }
      if (this.checkExperPcnt(this.experPcnt)) {
        return false;
      }
      if (this.pgDiv === 'P' && (this.chkChildAge || this.chkYouthAge || this.chkSkillAge) && !this.childAgeAgree) {
        alert('체험연령 관련 주의사항에 동의를 해주세요.');
        return false;
      }
      if (this.pgDiv === 'P' && !this.privateAgree) {
        alert('개인정보제공 동의를 해주세요.');
        return false;
      }
      if (this.experPcnt === 0) {
        alert('체험인원을 선택해 주세요.');
        return false;
      }
      if (this.groupPersDiv === '02') {
        for (let i = 0; i < this.experPcntList.length; i++) {
          const pcntInfo = this.experPcntList[i];
          if (!pcntInfo.incluNm) {
            alert('체험자 이름은 필수 값 입니다.');
            return false;
          }
          if (!pcntInfo.incluBirthMonDate) {
            alert('체험자 생년월일은 필수 값 입니다.');
            return false;
          }
          if (pcntInfo.incluBirthMonDate == new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()) {
            alert('체험자의 생년월일을 입력해주세요.');
            return false;
          }
          if (this.isYouthOrSkill && !pcntInfo.email) {
            alert('체험자 이메일은 필수 값 입니다.');
            return false;
          }
          if (pcntInfo.expProduct) {
            const selExph = pcntInfo.expProduct.every((e) => {
              return !!e.exhpHzCd;
            });
            if (!selExph) {
              alert(pcntInfo.incluNm + ' 체험자의 체험실을 선택해 주세요.');
              return false;
            }
          }

          if (this.productExphList?.length > 0) {
            const overSelect = this.productExphList.every((p) => {
              return p.roadList.every((road) => {
                return road.exphList.every((exph) => {
                  if (exph.exhpRvResiduePcnt < exph.exhpAppPcnt) {
                    alert('체험실 잔여석 보다 체험실이 초과 선택 되었습니다.\n(' + `${exph.scheSeqNo}회차 ${exph.exhpHallNm})`);
                    return false;
                  } else {
                    return true;
                  }
                });
              });
            });
            if (!overSelect) {
              return false;
            }
          }
        }

        const duplChk = this.experPcntList.some((value, index, self) => {
          return (
            self.findIndex((t, j) => j > index && t.incluNm === value.incluNm && t.incluBirthMonDate === value.incluBirthMonDate && t.email === value.email) > 0
          );
        });
        if (duplChk) {
          alert('동일체험자가 존재합니다. 체험자를 확인해 주세요.');
          return false;
        }
      } else {
        if (!this.orgInfo.orgName) {
          alert('단체명은 필수 값 입니다.');
          return false;
        }
        if (!this.orgInfo.basicAddress) {
          alert('단체주소는 필수 값 입니다.');
          return false;
        }
        if (!(this.orgInfo.grades?.length > 0)) {
          alert('학년은 필수 값 입니다.');
          return false;
        }
      }

      //인솔자 보호자 가격이 있을 경우
      const leaderPrice = this.productPriceList.find((e) => e.reciDivCd === '10');
      if (leaderPrice) {
        if (this.ticket.leaderPcnt === 0 || this.leaderPcntList.reduce((a, e) => a + e.pcnt, 0) === 0) {
          alert(`${leaderPrice.reciDivNm}를 선택해 주세요.`);
          return false;
        }

        let pesnDivCd07Cnt = 0;
        for (let i = 0; i < this.leaderPcntList.length; i++) {
          const leaderInfo = this.leaderPcntList[i];
          if (!leaderInfo.leaderNm) {
            alert(leaderPrice.reciDivNm + ' 이름은 필수 값 입니다.');
            return false;
          }
          if (!leaderInfo.phoneNo) {
            alert(leaderPrice.reciDivNm + ' 휴대폰번호는 필수 값 입니다.');
            return false;
          }
          if (!leaderInfo.email) {
            alert(leaderPrice.reciDivNm + ' 이메일은 필수 값 입니다.');
            return false;
          }
          if (leaderInfo.pesnDivCd === '07') {
            pesnDivCd07Cnt++;
          }
        }

        if (pesnDivCd07Cnt > 0 && this.experPcnt / pesnDivCd07Cnt < 15) {
          alert('단체인솔자 할인은 인솔자 1인당 체험자가 15명 이상이여야 합니다.');
          return false;
        }

        const leDuplChk = this.leaderPcntList.some((value, index, self) => {
          return (
            self.findIndex((t, j) => j > index && t.leaderNm === value.leaderNm) > 0
            //self.findIndex((t, j) => j > index && t.incluNm === value.incluNm && t.incluBirthMonDate === value.incluBirthMonDate && t.email === value.email) > 0
          );
        });

        if (leDuplChk) {
          alert('동일 보호자/인솔자가 존재합니다.');
          return false;
        }
      }

      //인원 검증
      const bValid = await orderValid([{ ...this.reserveInfo }]);

      return bValid;
    },
    async onJustAddCartClick() {
      if (await this.reserveValid()) {
        const item = { ...this.reserveInfo, groupPersDiv: this.groupPersDiv, inviteYn: 'Y' };
        const result = await this.addCartItem({ cartItem: item, replace: false });
        this.cancelCoupon();
        if (result) {
          alert('상품이 체험바구니에 추가되었습니다.');
        }
      }
    },
    async onGoCartClick() {
      customConfirm('체험바구니로 이동하시겠습니까?', (confirm) => {
        if (confirm) {
          this.$router.push('/' + this.currentRouteType + '/cart');
        }
      });
    },
    async onPledgeCmplClick() {
      if (await this.reserveValid()) {
        this.updateBookingList({ bookingList: [{ ...this.reserveInfo, groupPersDiv: this.groupPersDiv, inviteYn: 'Y' }], mode: 'pledgeCmpl' });
        this.$router.push('/' + this.currentRouteType + '/payment');
      }
    },
    notPledegeOnly() {
      // 확약서 전용 상품 확인
      const onlyPledegeList = ['724', '898', '916']; // 확약서예약 만 사용할 상품번호 추가
      let result = onlyPledegeList.indexOf(this.$route.params.id) === -1; // this.$route.params.id 상품번호
      return result;
    },
  },
  created() {
    this.checkExperPcnt = this.pcntVaild();
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: relative;

  & .loading-indicator {
    background: rgba(255, 255, 255, 0.6);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

dt {
  position: relative;
}
dd {
  padding-top: 15px;
}

.ticket-accordion {
  & > li {
    border-top: 1px solid #ccc;
    padding-top: 9px;
    padding-bottom: 6px;
  }
  & > li:last-child {
    border-bottom: 1px solid #ccc;
    display: block;
  }

  & .content-block {
    padding: 5px 0;
  }
  .pers_list li span {
    width: calc(100% - 200px);
  }
  & .pers_list li i {
    width: 110px;
  }
}
#prodRegist .selBox dl {
  border-top: none;
}

.buy_date {
  flex: 1;
  justify-content: space-between;
}

.sel_time {
  justify-content: space-between;
  & strong {
    padding-left: 5px;
  }
  & li.checkbox {
    //width: calc(50% - 11px);
  }
}
.totalBox .org-price {
  font-size: 22px;
  color: #999;
  text-decoration: line-through;
}
.ttPrice {
  transition: color 0.3s;
}
.price-loading {
  color: #ddd;
}

@media all and (max-width: 540px) {
  .totalBox .org-price {
    font-size: 18px;
  }
}
</style>
